import { render, staticRenderFns } from "./PreBidsList.vue?vue&type=template&id=36033109&scoped=true"
import script from "./PreBidsList.vue?vue&type=script&lang=js"
export * from "./PreBidsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36033109",
  null
  
)

export default component.exports